import { useState } from "react";
import { keyframes } from "@emotion/react";
import {
  Box,
  Typography,
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Chip,
} from "@mui/material";
import { useScoresData, useIncrement, useDecrement } from "../hooks/useScores";

export const QAndA = ({ goNext, question, questionIndex, isFinished }) => {
  const [alignment, setAlignment] = useState(undefined);

  const handleOnChange = (_, newAlignment) => {
    setAlignment(newAlignment);
  };

  const scores = useScoresData();
  console.log(scores);

  const increment = useIncrement();
  const decrement = useDecrement();

  const handleOnClick = () => {
    if (alignment === "yes") {
      question.courses.forEach((course) => {
        increment(course);
      });
    }
    if (alignment === "no") {
      question.courses.forEach((course) => {
        decrement(course);
      });
    }

    setAlignment(undefined);
    goNext();
  };

  const disabled = !alignment || isFinished;

  return (
    <>
      {isFinished || (
        <Chip
          variant="outlined"
          color="primary"
          label={`Question ${questionIndex + 1}`}
        />
      )}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        {isFinished ? (
          <Typography
            sx={{ opacity: 0, animation: `${popUp} .6s .2s ease forwards` }}
          >
            終了！
          </Typography>
        ) : (
          <Typography>{question.text}</Typography>
        )}
      </Box>
      <ToggleButtonGroup
        color="primary"
        value={alignment}
        exclusive
        onChange={handleOnChange}
        sx={{ width: "100%", marginBottom: "40px" }}
      >
        <ToggleButton value="yes" sx={{ flex: 1 }}>
          はい
        </ToggleButton>
        <ToggleButton value="neither" sx={{ flex: 1 }}>
          どちらでもない
        </ToggleButton>
        <ToggleButton value="no" sx={{ flex: 1 }}>
          いいえ
        </ToggleButton>
      </ToggleButtonGroup>
      <Button
        variant="contained"
        onClick={handleOnClick}
        disabled={disabled}
        sx={{ marginBottom: "20px", maxWidth: "400px", width: "100%" }}
      >
        次へ
      </Button>
    </>
  );
};

const popUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(100%);
  }
  to {
    opacity: 1;
    transform: translateY(0%);
  }
`;
